import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-97ba715c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"#607D8B"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"margin-bottom":"0em","color":"#607D8B"} }, "Sign in", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Please sign in to send an application.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "p-input-icon-left login" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-envelope" }, null, -1))
const _hoisted_9 = { class: "p-input-icon-left password" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-lock" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { style: {"margin-top":"3em"} }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Forgot password? ")
const _hoisted_14 = { style: {"margin-top":"1em"} }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Don't have an account? ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Message = _resolveComponent("Message")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.jobListing)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.jobListing.title), 1))
      : _createCommentVNode("", true),
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.pressed && _ctx.pressed(...args)), ["prevent"])),
      style: {"align-items":"center"}
    }, [
      _createElementVNode("span", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_InputText, {
          modelValue: _ctx.email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
          type: "email",
          placeholder: "Email",
          class: "input"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("span", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_InputText, {
          modelValue: _ctx.password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
          type: "password",
          placeholder: "Password",
          class: "input"
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_11,
      _createVNode(_component_Button, {
        type: "submit",
        label: "Sign in",
        class: "p-button-secondary"
      }),
      _createElementVNode("span", _hoisted_12, [
        _createElementVNode("i", null, [
          _hoisted_13,
          _createElementVNode("b", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sendResetPasswordMail && _ctx.sendResetPasswordMail(...args))),
            style: {"cursor":"pointer","color":"#607D8B"}
          }, "Click here")
        ])
      ])
    ], 32),
    (_ctx.error)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 1,
          class: "mt-5",
          severity: "error",
          closable: false
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.error), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.infoMessage)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 2,
          class: "mt-5",
          severity: "success"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.infoMessage), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_14, [
      _createElementVNode("i", null, [
        _hoisted_15,
        _createElementVNode("b", {
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goToSignup && _ctx.goToSignup(...args))),
          style: {"cursor":"pointer","color":"#607D8B"}
        }, "Sign up")
      ])
    ])
  ]))
}